/**
 * LoginScreen Factory for Poker Reborn
 *
 * Platform-aware factory that returns WebLoginScreen or NativeLoginScreen.
 * Both share the same public API (LoginScreenBase) so consumers are platform-agnostic.
 *
 * @see docs/screens/login/README.md - General login flow
 * @see docs/screens/login/WEB.md - Web implementation
 * @see docs/screens/login/NATIVE.md - Native implementation
 */

import { authService } from '@/services/AuthService';
import { LoginScreenBase } from './LoginScreenBase';
import { WebLoginScreen } from './WebLoginScreen';
import { NativeLoginScreen } from './NativeLoginScreen';

export { LoginScreenBase };

/** Create the platform-appropriate login screen */
export function createLoginScreen(width: number, height: number): LoginScreenBase {
  const urlParams = new URLSearchParams(window.location.search);
  const isNative = urlParams.get('native') === 'true' || authService.isNativePlatform();

  return isNative
    ? new NativeLoginScreen(width, height)
    : new WebLoginScreen(width, height);
}
